import React from "react";

export default function EmptyState() {
  return(
    <div className="emptyState _paddingTop--xxxxlarge">
      <i className="materialIcon --large">move_to_inbox</i>
      <p className="byline">You have no alerts</p>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/alertsManager/components/EmptyState.js